<template>
  <router-link tag="li" :to="content.route" @click.native="handleClick" class="menu-item" :class="customClasses">
    <a>
      <span>{{ content.text }}</span>
      <BaseIcon v-if="content.children" type="chevron-down" />
    </a>
    <TheMenuSublevel v-if="content.children" v-show="isActive" :items="content.children" :position="sublevelPosition" @close="handleClose" />
  </router-link>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import TheMenuSublevel from './TheMenuSublevel'
import BaseIcon from '@base/BaseIcon'

export default {
  name: 'TheMenuItem',
  props: {
    index: {
      type: Number,
      required: true
    },
    content: {
      type: Object,
      required: true,
      validator: (value) => {
        return (value.route !== '' && value.text !== '')
      }
    }
  },
  components: {
    TheMenuSublevel,
    BaseIcon
  },
  data () {
    return {
      isActive: false
    }
  },
  computed: {
    ...mapGetters({
      navigationLength: 'header/getMenuLength',
      currentActive: 'header/getCurrentActive'
    }),
    customClasses () {
      return [
        {
          'has-children': this.content.children,
          'is-open': this.isActive
        }
      ]
    },
    sublevelPosition () {
      return (this.index === this.navigationLength - 1) ? 'right' : 'left'
    }
  },
  watch: {
    currentActive () {
      this.isActive = (this.index === this.currentActive)
    }
  },
  methods: {
    ...mapActions({
      updateCurrentActive: 'header/updateCurrentActive'
    }),
    handleClick () {
      this.updateCurrentActive((this.currentActive !== this.index) ? this.index : -1)
    },
    handleClose () {
      this.isActive = false
    }
  }
}
</script>

<style lang="scss">
  .menu-item{
    @include media("small-medium"){
      width: 100%;
      justify-content: flex-start;
      flex-direction: column;
      border-top: 1px solid shade(colors("foreground"), 10%);
    }
    @include media("large"){
      justify-content: space-between;

      &:not(:last-of-type){
        border-right: 1px solid shade(colors("foreground"), 10%);
      }
    }

    position: relative;
    display: flex;
    align-items: center;
    flex: 0 1 auto;

    &.route-active,
    &.route-exact-active{
      > a{
        color: colors("primary");
      }
    }

    > *{
      flex: 0 1 auto;
    }

    > a{
      @include text-color(colors("font"), colors("primary"));
      @include media("small-medium"){
        position: relative;
        z-index: 1;
      }

      display: flex;
      justify-content: space-between;
      width: 100%;
      text-transform: uppercase;
      font-weight: font-weights("medium");
      padding: layout("spacing")/2 layout("spacing");

      > *{
        flex: 0 1 auto;
      }
    }

    &.has-children{
      > a > span{
        margin-right: layout("spacing");
      }

      &.is-open{
        > a{
          @include media("small-medium"){
            box-shadow: 0 .3rem .5rem 0 rgba(black, 0.09);
          }
          color: colors("primary");
        }
      }
    }
  }
</style>
